<template>
  <ProlongSubscriptionResolver>
    <template v-slot:default="{error,errorStripe,loader, prolongSubscriptionPayment, hasActivePaymentMethod}">
      <PaymentDashboardMessage>
        <template #icon>
          <svg
            width="26"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M28.9999 14.3637L26.4544 11.8182L22.6362 15.6365L18.8179 11.8182L16.2725 14.3637L20.0907 18.1819L16.2725 22.0002L18.8179 24.5457L22.6362 20.7274L26.4544 24.5457L28.9999 22.0002L25.1817 18.1819L28.9999 14.3637Z" stroke="#EA0D0D" stroke-miterlimit="10" />
            <path d="M28.3639 10.5456V2.90911C28.3639 1.82728 27.5367 1 26.5185 1H2.97275C1.89092 1 1 1.82728 1 2.90911V18.182C1 19.2638 1.89092 20.0911 2.97275 20.0911H15.0002" stroke="#EA0D0D" stroke-miterlimit="10" />
            <path d="M1 4.81812H28.3639" stroke="#EA0D0D" stroke-miterlimit="10" />
            <path d="M1 8.63629H28.3639" stroke="#EA0D0D" stroke-miterlimit="10" />
            <path d="M2.91016 11.182H7.36475" stroke="#EA0D0D" stroke-miterlimit="10" />
          </svg>
        </template>
        <template #title>
          {{ $t('prolongationFailed') }}
        </template>
        <template #subtitle>
          {{ $t('youCan') }}
        </template>
        <template #items>
          <PaymentDashboardMessageItem >
            <template #left>
              {{ $t('replaceActiveCard') }}
            </template>
            <template #right>
              <VBtn
                @click="changePaymentMethod"
                color="success"
              >
                {{ $t('change') }}
              </VBtn>
            </template>
          </PaymentDashboardMessageItem>
          <PaymentDashboardMessageItem>
            <template #left>
              {{ $t('tryToCharge') }}
            </template>
            <template #right>
              <VBtn
                class="card-alert__btn"
                :disabled="!hasActivePaymentMethod"
                @click="loader(() => prolongSubscriptionPayment())"
                color="success"
              >
                {{ $t('prolongSubscription') }}
              </VBtn>
            </template>
          </PaymentDashboardMessageItem>
        </template>
      </PaymentDashboardMessage>
      <div v-if="error || errorStripe">
        <div class="card-alert">
          {{ error || errorStripe }}
        </div>
      </div>
    </template>
  </ProlongSubscriptionResolver>
</template>

<script>
import ProlongSubscriptionResolver from '@/components/Payment/Subscription/ProlongSubscriptionResolver';
import PaymentDashboardMessage from '@/components/Payment/Dashboard/PaymentDashboardMessage';
import PaymentDashboardMessageItem from '@/components/Payment/Dashboard/PaymentDashboardMessageItem';
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'PaymentDashboardProlongSubscription',
  components: { PaymentDashboardMessageItem, PaymentDashboardMessage, ProlongSubscriptionResolver },
  setup(_, { root: { $router } }) {
    function changePaymentMethod() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.INFO } });
    }

    return {
      changePaymentMethod,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(234, 13, 13, 0.05);
  border: 1px solid rgba(234, 13, 13, 0.2);
  border-radius: 0.375rem;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.14;
  color: #EA0D0D;
  padding: 0.875rem 1.125rem;
  margin: 1rem 0 0 0;
  svg {
    vertical-align: middle;
    margin-right: 0.375rem;
  }
  &__btn {
    background: #1FC57F;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.24);
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    justify-self: right;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.21;
    letter-spacing: 0.02em;
    color: #FFFFFF;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .card-alert {
    display: block;
    align-items: center;
    justify-content: space-between;
    background: rgba(234, 13, 13, 0.05);
    border: 1px solid rgba(234, 13, 13, 0.2);
    border-radius: 0.375rem;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.14;
    color: #EA0D0D;
    padding: 0.875rem 1.125rem;
    margin: 1rem 0 0 0;
  }
}
</style>

<i18n lang="yml" locale="ru">
prolongationFailed: Последняя попытка продления подписки была безуспешной
youCan: Вы можете
replaceActiveCard: Заменить активную карту
tryToCharge: Попробовать еще раз оплатить с активной карты
prolongSubscription: Продлить подписку
change: Изменить
</i18n>
<i18n lang="yml" locale="en">
prolongationFailed: The last attempt to extend your subscription was unsuccessful. Please choose another card and click Retry button.
youCan: You can
replaceActiveCard: Change active card
tryToCharge: Try to pay again with an active card
prolongSubscription: Extend subscription
change: Change
</i18n>
